import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
import { PRICE } from '../data/pack';
const fmt = (n: number) => n.toString().padStart(2, '0');
export function useCountdown(startHours = 1) {
  const [timeLeft, setTimeLeft] = useState({
    h: startHours,
    m: 0,
    s: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return timeLeft;
}
export const formatClock = (t: {
  h: number;
  m: number;
  s: number;
}) => `${fmt(t.h)}:${fmt(t.m)}:${fmt(t.s)}`;
export function UrgencyBanner() {
  const timeLeft = useCountdown(1);
  const content = <>
      <div className="flex shrink-0 items-center gap-1.5 text-brand-goldLight" data-id="element-240" data-mp="1guro5ml4k2ip">
        <ClockIcon className="h-3.5 w-3.5 shrink-0 md:h-4 md:w-4" data-id="element-241" data-mp="27frmcrbgrlkb" />
        <span className="uppercase tracking-wide" data-id="element-242" data-mp="22o9le39fxkzc">
          Special launch price ends in
        </span>
        <span className="ml-0.5 rounded-sm bg-brand-surface/15 px-1.5 py-0.5 font-display font-semibold tabular-nums text-brand-surface" data-id="element-243" data-mp="1xodi668khxku">
          {formatClock(timeLeft)}
        </span>
      </div>
      <span className="h-1 w-1 shrink-0 rounded-full bg-brand-goldLight/50 md:h-4 md:w-px md:rounded-none md:bg-brand-goldLight/40" data-id="element-244" data-mp="2qe3z0n1l3dkn" />
      <span className="shrink-0" data-id="element-245" data-mp="2lfsn86rqaszs">
        Instant Access · 100% Digital · Only {PRICE}
      </span>
      <a href="#whats-inside" className="inline-flex shrink-0 items-center rounded-sm bg-brand-goldLight px-3 py-0.5 font-display text-[10px] font-semibold uppercase tracking-[0.14em] text-brand-ink transition-colors duration-200 ease-out hover:bg-brand-gold md:py-1 md:text-xs" data-id="element-246" data-mp="2ge39gjd4g180">
        See the Complete Bundle
      </a>
    </>;
  return <div className="sticky top-0 z-50 w-full border-b border-brand-gold/40 bg-brand-ink text-brand-surface" data-id="element-247" data-mp="12f9yo374mof8">
      <div className="mx-auto max-w-7xl px-3 py-2 md:px-6 md:py-2.5" data-id="element-248" data-mp="17f63u5rk8lwd">
        <div className="relative overflow-hidden md:hidden" data-id="element-249" data-mp="shnf33evu8ox">
          <motion.div className="flex w-max items-center gap-6 whitespace-nowrap text-[11px] font-medium" animate={{
          x: ['0%', '-50%']
        }} transition={{
          duration: 24,
          ease: 'linear',
          repeat: Infinity
        }} data-id="element-250" data-mp="shdnxci3pvhn">
            {[0, 1].map(dup => <div key={dup} className="flex shrink-0 items-center gap-6" data-id="element-251" data-mp="ogtou3dywhsv">
                {content}
              </div>)}
          </motion.div>
        </div>
        <div className="hidden items-center justify-center gap-6 text-sm font-medium md:flex" data-id="element-252" data-mp="epflfkiwaxug">
          {content}
        </div>
      </div>
    </div>;
}